import { render, staticRenderFns } from "./UserInviteAllTab.vue?vue&type=template&id=4630fa3b&scoped=true"
import script from "./UserInviteAllTab.vue?vue&type=script&lang=js"
export * from "./UserInviteAllTab.vue?vue&type=script&lang=js"
import style0 from "./UserInviteAllTab.vue?vue&type=style&index=0&id=4630fa3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4630fa3b",
  null
  
)

export default component.exports